import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FaqItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FaqItem({
  question,
  answer,
  isOpen,
  onClick
}: FaqItemProps) {
  return <div className="border-b border-brand-lavenderDark/30 last:border-0" data-id="element-29">
      <button className="w-full py-6 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-purple rounded-lg px-2" onClick={onClick} aria-expanded={isOpen} data-id="element-30">
        <span className="font-serif text-xl text-brand-slate font-semibold pr-4" data-id="element-31">
          {question}
        </span>
        <ChevronDownIcon className={`w-6 h-6 text-brand-purple transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-32" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ease-in-out px-2 ${isOpen ? 'max-h-96 opacity-100 pb-6' : 'max-h-0 opacity-0'}`} data-id="element-33">
        <p className="text-lg text-brand-navy leading-relaxed" data-id="element-34">{answer}</p>
      </div>
    </div>;
}
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Esto funciona si llevo años siendo ansiosa?',
    answer: 'Sí, porque no tratamos tu pasado, sino tu respuesta física presente.'
  }, {
    question: '¿Necesito equipo especial?',
    answer: 'No, solo tu propia respiración y tus sentidos.'
  }, {
    question: '¿Es seguro si tengo otras condiciones de salud?',
    answer: 'Es una técnica de respiración natural, pero siempre recomendamos consultar con tu médico.'
  }, {
    question: '¿Puedo leerlo en mi celular?',
    answer: 'Sí, está optimizado para cualquier dispositivo móvil.'
  }];
  return <section className="w-full py-24 px-4 bg-brand-cream" data-id="element-35">
      <div className="max-w-3xl mx-auto" data-id="element-36">
        <div className="text-center mb-16" data-id="element-37">
          <span className="text-brand-purple font-semibold tracking-wider uppercase text-sm mb-4 block" data-id="element-38">
            Preguntas frecuentes
          </span>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-brand-slate" data-id="element-39">
            Resolvemos tus dudas
          </h2>
        </div>

        <div className="bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-brand-creamDark" data-id="element-40">
          {faqs.map((faq, index) => <FaqItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-41" />)}
        </div>
      </div>
    </section>;
}